<template>
  <div class="thumb-card" :style="isAnnotated" @click="$emit('click')">
    <v-progress-circular v-if="isLoading" class="escalon-absolute-center" indeterminate />
    <div v-else-if="isCirrus && isUserPrefBlackAndWhiteCirrusView && imageHTMLObj && !isCirrusReference ">
      <pixel-shaded-canvas 
        :img="imageHTMLObj"
        :colorSettings="colorSettings"
        :canvasSize="imgSize"
        :imgSize="imgSize"
        :dontUseWebgl="dontUseWebgl"/>
    </div>
    <div v-else 
      class="escalon-background-image" 
      :style="style" 
      :title="title"/>
      
    <v-icon v-if="isVideo" :style="iconStyle" :color="colorHex">fas fa-film</v-icon>
    <span id="image-eye" :class="colorClass">{{image.imgEye}}
      <span class="tooltiptext">{{image.flSrNo}}</span>
    </span>
    <span id="timespan">{{image.imgTimeStamp}}</span>
    <thumbnail-misc v-if="showMisc"
     :imgSize="imgSize"
     :thumbnailAnnotation="thumbnailAnnotation" 
     :showDropdown="showDropdown"
     @multiview-launch="multiviewLaunch"/>
    <v-checkbox 
      v-if="isMultiview"
      class="thumb-checkbox"
      :color="colorHex"
      :input-value="isSelected"
      @click.stop="$emit('clickCheckbox')"></v-checkbox>
  </div>
</template>
<script>
import pixelShadedCanvas from "../../canvas/components/PixelShadedCanvas";
import thumbnailMisc from "./ThumbnailMisc";
import thumbnailUtl from "../mixins/ThumbnailUtl";
import { defaultColorSettings } from "../../canvas/canvasUtils";
import { GRAYSCALE_MODES } from "../../config/config";

export default {
  name: "Thumbnail",
  components: { pixelShadedCanvas, thumbnailMisc},
  props: {
    image: Object,
    index: Number,
    isCirrus: Boolean,
    isMultiview: Boolean, 
    isUserPrefBlackAndWhiteCirrusView: Boolean
  },
  data() {
    return {
      colorSettings: defaultColorSettings(GRAYSCALE_MODES.REC709, false)
    };
  },
  methods:{
    multiviewLaunch(launchOption){
      this.$store.dispatch("openOCTMultiviewFromThumbnail", {image: this.image, launchOption: launchOption});
    }
  },
  mixins: [thumbnailUtl],
  computed: {
    dontUseWebgl(){
      return this.isMultiview;
    },
    isSelected(){
      if (this.isMultiview)
        return this.$store.getters.imageIsSelectedInMultiview(this.image);
      return false;
    },
    inf(){
      return require("../../assets/INF.png");
    },
    imageSrc(){
      if (!this.image) return "";
      if (this.image.thumbNotFound) return this.inf;
      return this.image.thumbObjectUrl;
    },
    imageHTMLObj() {
      if (!this.image || !this.image.thumbHtmlObject) return null;
      return this.image.thumbHtmlObject;
    },
    imgSize() {
      let proportion = this.image.thumbSize.w / this.image.thumbSize.h;
      return {
          w: 130 * proportion,
          h: 130
        };
    },
    style(){
      return { 
        "background-image": "url('" + this.imageSrc + "')"
      };
    },
    title(){
      if (this.image.thumbNotFound) return "Image Not Found";
      return "Image #" + (this.index + 1);
    },
    isLoading() {
      return this.image.thumbIsLoading;
    },
    isAnnotated() {
      if (this.image.isAnnotated) {
        return {
          "border": "2px solid " + this.colorHex
        };
      }
      return "";
    },
    isVideo() {
      return this.image.imgType == "VIDEO";
    },
    iconStyle() {
      return {
        "position": "absolute",
        "left": "86px",
        "top": "52px"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
  .thumb-card ::v-deep {
    margin: 5px;
    position: relative;
    height: 130px;
    width: 200px;
    display: inline-block;
    border: 1px solid $color-grey;

    span {
      position: absolute;
      right: 10px;
      bottom: 10px;
      user-select: none;
    }

    #timespan {
      left: 5px;
    }
    #image-eye {
      .tooltiptext {
        visibility: hidden;
        width: 100px;
        background-color: #616161;
        color: #fff;
        text-align: center;
        border-radius: 6px;

        /* Position the tooltip */
        position: absolute;
        z-index: 1;
      }
      &:hover .tooltiptext {
        visibility: visible;
      }
    }
  }

  .thumb-card:hover{
    background-color: $color-grey;
    cursor: pointer;
  }
</style>
